import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import Conditional from '@app/components/common/Conditional';

const SingleByteExceptionMessage = ({ languageId, className }) => {
  const [t] = useTranslation();
  const defaultLanguage = useSelector(s => s.dealer.defaultLanguage);
  const isPCC_ShoppingCartSingleByteMessageJapan = useSelector(
    s => s.featureFlag?.PCC_ShoppingCartSingleByteMessageJapan
  );

  return (
    <Conditional
      test={
        defaultLanguage === languageId &&
        isPCC_ShoppingCartSingleByteMessageJapan
      }
    >
      <div
        className={cx(
          'd-flex align-items-start pt-2 text-sm u-color--DarkGray',
          className
        )}
      >
        {t('SINGLE_BYTE_CHARACTER_INPUT_PROMPT')}
      </div>
    </Conditional>
  );
};

export default SingleByteExceptionMessage;

SingleByteExceptionMessage.propTypes = {
  languageId: PropTypes.string.isRequired,
  className: PropTypes.string
};
